import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { type PlayerDto, playerDtoToModel } from '@/models/players';

const getPlayer = async (playerId: string): Promise<PlayerDto> => {
  const response = await api.get<PlayerDto>(`/v1/player/${playerId}`);
  return response.data;
};

export const getPlayerQuery = (playerId: string) => ({
  queryKey: ['player', playerId],
  queryFn: async () => getPlayer(playerId),
  enabled: !!playerId,
  select: (player: PlayerDto) => playerDtoToModel(player),
});

export const usePlayer = (playerId: string) => {
  return useQuery(getPlayerQuery(playerId));
};
